import { render, staticRenderFns } from "./Trash-Delete-Prompt.vue?vue&type=template&id=c01b3a24&scoped=true&"
import script from "./Trash-Delete-Prompt.vue?vue&type=script&lang=js&"
export * from "./Trash-Delete-Prompt.vue?vue&type=script&lang=js&"
import style0 from "./Trash-Delete-Prompt.vue?vue&type=style&index=0&id=c01b3a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01b3a24",
  null
  
)

export default component.exports